export const formatDate = (oldDate) => {
  let newDate = new Date(oldDate).toLocaleDateString("en-GB", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
  return newDate;
};

export const formatDesignDateAdd_11_30 = (isoString) => {
  let date = new Date(isoString);
  date.setSeconds(84600);
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "UTC",
  });
};

export const formatDesignDate = (isoString, replaceWith) => {
  if (!isoString) return false;
  const date = new Date(isoString);
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };

  const formatted = !replaceWith
    ? date.toLocaleString("en-GB", options).replace(/(am|pm)/i, (match) => match.toUpperCase())
    : date
        .toLocaleString("en-GB", options)
        .replace(",", ` ${replaceWith}`)
        .replace(/(am|pm)/i, (match) => match.toUpperCase());

  return formatted;
};

// Format Like DD/MM/YY
export const formatDateDDMMYY = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

export const formatOrderDate = (isoString) => {
  // const date = new Date(isoString);

  const options = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    // timeZone: "UTC",
  };

  // const formattedDate = new Intl.DateTimeFormat("en-GB", options).format(date);
  const formattedDate = new Date(isoString).toLocaleDateString("en-GB", options);

  return (formattedDate.replace(formattedDate.slice(-2), "") + formattedDate.slice(-2).toUpperCase()).replace(",", " -");
};

// Format Like "2025-06-13"
export const formatDateYYMMDD = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// May 2, 2025
export const formatActivityDate = (oldDate) => {
  return new Date(oldDate).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

// 16th Oct, 2025
export const formatDateWithSuffix = (dateStr) => {
  const date = new Date(dateStr);

  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" }); // e.g., Feb
  const year = date.getFullYear();

  const getDaySuffix = (d) => {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${getDaySuffix(day)} ${month}, ${year}`;
};

export const getFinancialYearStart = (dateStr) => {
  const date = dateStr ? new Date(dateStr) : new Date();
  const year = date.getFullYear();

  const fyStartYear = date.getMonth() + 1 < 4 ? year - 1 : year;

  const startDate = new Date(fyStartYear, 3, 1);

  return formatDateWithSuffix(startDate);
};
